module.exports = __webpack_public_path__ + "img/default_profile.6389c0cf.png";